// extracted by css-extract-rspack-plugin
export default {"navigation":"navigation-YaIHvU","logout":"logout-fV0sWX"};